import { INSIGHT_CATEGORY } from "../Types/account";
import type { OutreachLaunchParams } from "./outreachNavigation";

type TargetFields = {
  target_type?: unknown;
  insight_item_id?: unknown;
  asset_id?: unknown;
  industry_insight_id?: unknown;
  account_insight_id?: unknown;
  contact_id?: unknown;
};
type OutreachTarget = Pick<OutreachLaunchParams, "insightId" | "category" | "origin">;

/** Preserve UUID anchors; numeric source IDs remain distinct from canonical items. */
export function assistantOutreachTarget(value: TargetFields, inferSeriesType = false): OutreachTarget | null {
  const target = value.target_type ?? (inferSeriesType
    ? value.insight_item_id != null ? "INSIGHTS_ITEM"
      : value.asset_id != null ? "ASSET_INSIGHT"
        : value.industry_insight_id != null ? "INDUSTRY_INSIGHT"
          : value.account_insight_id != null ? "ACCOUNT_INSIGHT"
            : value.contact_id != null ? "CONTACT_INTELLIGENCE" : null
    : null);
  if (target === "INSIGHTS_ITEM") {
    const id = value.insight_item_id;
    return typeof id === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id)
      ? { insightId: null, category: "INSIGHTS_ITEM", origin: { kind: "INSIGHTS_ITEM", id } }
      : null;
  }
  const anchor = target === "ASSET_INSIGHT" ? { id: value.asset_id, category: INSIGHT_CATEGORY.ASSET }
    : target === "INDUSTRY_INSIGHT" ? { id: value.industry_insight_id, category: INSIGHT_CATEGORY.INDUSTRY }
      : target === "ACCOUNT_INSIGHT" ? { id: value.account_insight_id, category: INSIGHT_CATEGORY.ACCOUNT }
        : target === "CONTACT_INTELLIGENCE" ? { id: value.contact_id, category: "CONTACT_INTELLIGENCE" as const } : null;
  return anchor && typeof anchor.id === "number" && Number.isSafeInteger(anchor.id) && anchor.id > 0
    ? { insightId: anchor.id, category: anchor.category } : null;
}
